
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"offerFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mark_slug_array"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folder_slug_array"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"generation_slug_array"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engine_type_id_array"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"body_type_id_array"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gearbox_id_array"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"drive_type_id_array"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owner_id_array"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year_from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price_to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerFilters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"site_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"mark_slug_array"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mark_slug_array"}}},{"kind":"Argument","name":{"kind":"Name","value":"folder_slug_array"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folder_slug_array"}}},{"kind":"Argument","name":{"kind":"Name","value":"generation_slug_array"},"value":{"kind":"Variable","name":{"kind":"Name","value":"generation_slug_array"}}},{"kind":"Argument","name":{"kind":"Name","value":"engine_type_id_array"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engine_type_id_array"}}},{"kind":"Argument","name":{"kind":"Name","value":"body_type_id_array"},"value":{"kind":"Variable","name":{"kind":"Name","value":"body_type_id_array"}}},{"kind":"Argument","name":{"kind":"Name","value":"gearbox_id_array"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gearbox_id_array"}}},{"kind":"Argument","name":{"kind":"Name","value":"drive_type_id_array"},"value":{"kind":"Variable","name":{"kind":"Name","value":"drive_type_id_array"}}},{"kind":"Argument","name":{"kind":"Name","value":"owner_id_array"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owner_id_array"}}},{"kind":"Argument","name":{"kind":"Name","value":"year_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year_from"}}},{"kind":"Argument","name":{"kind":"Name","value":"price_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price_to"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferFilterValues"},"directives":[]}]}}]}}],"loc":{"start":0,"end":957}};
    doc.loc.source = {"body":"#import \"../../fragments/filters/offerFilterValues.gql\"\n\nquery offerFilters(\n  $site_id: Int,\n  $mark_slug_array: [String],\n  $folder_slug_array: [String],\n  $generation_slug_array: [String],\n  $engine_type_id_array: [Int],\n  $body_type_id_array: [Int],\n  $gearbox_id_array: [Int],\n  $drive_type_id_array: [Int],\n  $owner_id_array:[Int],\n  $year_from: Int,\n  # $year_to: Int,\n  # $price_from: Int,\n  $price_to: Int,\n) {\n  offerFilters(\n    site_id: $site_id,\n    mark_slug_array: $mark_slug_array,\n    folder_slug_array: $folder_slug_array,\n    generation_slug_array: $generation_slug_array,\n    engine_type_id_array: $engine_type_id_array,\n    body_type_id_array: $body_type_id_array,\n    gearbox_id_array: $gearbox_id_array,\n    drive_type_id_array: $drive_type_id_array,\n    owner_id_array: $owner_id_array,\n    year_from: $year_from,\n    # year_to: $year_to,\n    # price_from: $price_from,\n    price_to: $price_to\n  )\n  {\n    ... OfferFilterValues\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../../fragments/filters/offerFilterValues.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["offerFilters"] = oneQuery(doc, "offerFilters");
        
